<div class="spinner-wrapper" [ngClass]="isLoading? 'inner-loading' : ''">
    <div class="spinner">
        <img src="assets/images/logo/logo-icon.png" alt="Logo image" />
    </div>
</div>